import api from 'api';
import { Notify } from 'utils';

export const updateFirmConfig = (
  setFile: (file: any) => void,
  setPreview: (preview: any) => void,
  setIsModalOpen: (isOpen: boolean) => void,
  setFirmConfig: (config: any) => void,
  fileField: string,
  formData: any,
  file: any = null
) => {
  api.setFirmConfig(formData).then(({ data }) => {
    const newFile = data[fileField];
    setFile(newFile);
    setFirmConfig({
      data: {
        document_url: data.document_url
      }
    });
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    Notify.success(`File updated`);
    setIsModalOpen(false);
  });
};

export const handleFileChange = (
  event: any,
  updateFunction: (formData: any, file: any) => void,
  fieldName: string
) => {
  const file = event.target.files[0];
  if (file) {
    if (file.type.startsWith('image/')) {
      const formData = new FormData();
      formData.append(fieldName, file);
      updateFunction(formData, file);
    }
  } else {
    Notify.error('The file is not an image.');
  }
};

export const handleFileDelete = (
  updateFunction: (formData: any) => void,
  fieldName: string
) => {
  const formData = new FormData();
  formData.append(fieldName, '');
  updateFunction(formData);
};
